import salaryService from 'ApiService/Accountant/salaryService';
import { AuthContext } from 'contexts/AuthContext';
import { useContext, useEffect, useState } from 'react';

const SelectEmployee = ({
  setDisable,
  employeeData,
  setEmployeeData,
  employeeTypes,
  setEmployeesData,
  employeesData,
}) => {
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const { state } = useContext(AuthContext);

  const isSuperAdmin = state?.user?.role === 'superadmin';

  useEffect(() => {
    if (isSuperAdmin && state?.selectedBranch) {
      resetEmployeeSelections();
    }
  }, [isSuperAdmin && state?.selectedBranch]);

  const resetEmployeeSelections = () => {
    setEmployeesData([]);
    setEmployeeData((prev) => ({ ...prev, employeeId: '' }));

    if (employeeData?.employeeType) {
      handleEmployeeTypeChange({
        target: { value: employeeData.employeeType },
      });
    }
  };

  const handleEmployeeTypeChange = async (event) => {
    const employeeType = event.target.value;
    setEmployeeData({ ...employeeData, employeeType, employeeId: '' });
    setEmployeesData([]);

    if (!employeeType) return;

    setLoading(true);
    try {
      const response = await salaryService.getEmployee(
        employeeType,
        isSuperAdmin ? state.selectedBranch : ''
      );

      if (response.data.success) {
        setEmployeesData(response.data.employees);
      }
    } catch (error) {
      console.error('Failed to fetch employees:', error);
      setErrors((prev) => [
        ...prev,
        'Failed to fetch employees for this branch',
      ]);
    }
    setLoading(false);
  };

  const handleEmployeeIdChange = (event) => {
    const employeeId = event.target.value;
    setEmployeeData({ ...employeeData, employeeId });
  };

  useEffect(() => {
    const newErrors = [];
    if (!employeeData?.employeeType || !employeeData?.employeeId) {
      newErrors.push('Please fill in all fields.');
    }
    if (isSuperAdmin && !state?.selectedBranch) {
      newErrors.push('Please select a branch first.');
    }
    setErrors(newErrors);
    setDisable(newErrors.length > 0);
  }, [employeeData, isSuperAdmin && state?.selectedBranch, setDisable]);

  return (
    <div className="w-full rounded-lg px-3 pt-7 md:px-8">
      <div className="flex justify-center">
        <h4 className="text-lg font-bold text-navy-700 dark:text-white">
          Select Employee Information
        </h4>
      </div>

      <div className="mt-6 flex flex-col md:flex-row md:items-center md:justify-center md:gap-6">
        <div className="w-full md:w-1/2">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Employee Type
          </label>
          <select
            onChange={handleEmployeeTypeChange}
            value={employeeData?.employeeType}
            name="employeeType"
            className="mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
            disabled={isSuperAdmin && !state?.selectedBranch}
          >
            <option value="">Click here to Select Employee Type</option>
            {employeeTypes.map((type) => (
              <option key={type.value} value={type.value}>
                {type.display}
              </option>
            ))}
          </select>
        </div>

        <div className="w-full md:w-1/2">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Employee
          </label>
          {loading ? (
            <p className="mt-2 text-center">Loading employees...</p>
          ) : (
            <select
              onChange={handleEmployeeIdChange}
              value={employeeData?.employeeId}
              name="employeeId"
              className="mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
              disabled={
                !employeeData?.employeeType || employeesData.length === 0
              }
            >
              <option value="">Select Employee</option>
              {employeesData.map((employee) => (
                <option key={employee._id} value={employee._id}>
                  {employee.name} ({employee.email})
                </option>
              ))}
            </select>
          )}
        </div>
      </div>

      {errors.length > 0 && (
        <div className="mt-4 text-red-500">
          {errors.map((error, index) => (
            <p key={index}>{error}</p>
          ))}
        </div>
      )}
    </div>
  );
};

export default SelectEmployee;
